import { useNewUserAccessRights } from '@app/hooks';

export const useScheduleRights = () => {
  const {
    userAccessRights: {
      WorkSchedules: {
        IsCreate: creationInPresentAndFeature,
        IsDelete: deletionInPresentAndFeature,
        IsEdit: editionInPresentAndFeature,
        IsEditPast: editionInPast,
        IsDeletePast: deletionInPast,
      },
    },
  } = useNewUserAccessRights();

  return {
    creationInPresentAndFeature,
    deletionInPresentAndFeature,
    editionInPresentAndFeature,
    editionInPast,
    deletionInPast,
  };
};
